import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./listing.module.scss"


const SNGlisting = ( { }) => {



    return (
        <section className={styles.snglisting} id="events">
            <div className={styles.containfix}>
                <h1 className={styles.eventsheader}>UPCOMING<br /> <span className={styles.purplefy}>VIRTUAL EVENTS</span></h1>
                <div className={styles.outerColGrid}>
                    <div className={styles.divCol1}>


                        
                        
                        
                        
                        <a className={styles.listButtonNew} href="https://upgather.com/snglive/cloud/" target="_blank">
                            <div className={styles.eShell}>
                                <div className={styles.leftie}>
                                    <div className={styles.eTitle}>CLOUD</div>
                                    <div className={styles.eDate}>December 7, 2021</div>
                                </div>
                                <div className={styles.eLearn}>Learn More <i className="fa fa-caret-right"></i></div>
                                <div className={styles.clearme}></div>
                            </div>
                        </a>
                    </div>

                </div>



            </div>
         </section>
    )
}

export default SNGlisting
